export const fixedTimes = [
  '19:00:00Z',
  '03:00:00Z',
  '23:00:00Z',
  '05:00:00Z',
  '07:00:00Z',
  '08:30:00Z',
  '10:00:00Z',
  '11:00:00Z',
  '22:00:00Z',
  '13:23:00Z',
  '17:00:00Z',
  '09:00:00Z',
  '20:00:00Z',
  '14:00:00Z',
]

export const mockFixedPostFrequencyDataCount = [
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 15,
    viewCount: 525,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 58,
    viewCount: 252,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 66,
    viewCount: 641,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 56,
    viewCount: 622,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 57,
    viewCount: 253,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 35,
    viewCount: 763,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 12,
    viewCount: 64,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 42,
    viewCount: 937,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 19,
    viewCount: 451,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 50,
    viewCount: 961,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 27,
    viewCount: 353,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 37,
    viewCount: 127,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 28,
    viewCount: 68,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 24,
    viewCount: 959,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 16,
    viewCount: 678,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 76,
    viewCount: 688,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 15,
    viewCount: 425,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 88,
    viewCount: 372,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 3,
    viewCount: 153,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 79,
    viewCount: 6,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 23,
    viewCount: 653,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 21,
    viewCount: 834,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 41,
    viewCount: 850,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 90,
    viewCount: 593,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 53,
    viewCount: 215,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 88,
    viewCount: 447,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 85,
    viewCount: 848,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 60,
    viewCount: 616,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 21,
    viewCount: 195,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 81,
    viewCount: 767,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 64,
    viewCount: 935,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 25,
    viewCount: 606,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 61,
    viewCount: 440,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 33,
    viewCount: 762,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 93,
    viewCount: 594,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 81,
    viewCount: 710,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 61,
    viewCount: 492,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 15,
    viewCount: 859,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 20,
    viewCount: 210,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 80,
    viewCount: 664,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 75,
    viewCount: 193,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 28,
    viewCount: 359,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 24,
    viewCount: 281,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 85,
    viewCount: 102,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 42,
    viewCount: 204,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 66,
    viewCount: 592,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 92,
    viewCount: 55,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 28,
    viewCount: 680,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 45,
    viewCount: 563,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 67,
    viewCount: 488,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 86,
    viewCount: 239,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 25,
    viewCount: 219,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 30,
    viewCount: 807,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 13,
    viewCount: 553,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 20,
    viewCount: 346,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 92,
    viewCount: 351,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 35,
    viewCount: 652,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 50,
    viewCount: 535,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 37,
    viewCount: 251,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 70,
    viewCount: 833,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 71,
    viewCount: 638,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 43,
    viewCount: 440,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 28,
    viewCount: 854,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 80,
    viewCount: 915,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 11,
    viewCount: 500,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 88,
    viewCount: 822,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 50,
    viewCount: 803,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 30,
    viewCount: 179,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 85,
    viewCount: 403,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 38,
    viewCount: 489,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 77,
    viewCount: 736,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 34,
    viewCount: 139,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 55,
    viewCount: 284,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 15,
    viewCount: 349,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 56,
    viewCount: 580,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 65,
    viewCount: 859,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 75,
    viewCount: 844,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 21,
    viewCount: 951,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 97,
    viewCount: 326,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 17,
    viewCount: 573,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 42,
    viewCount: 105,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 43,
    viewCount: 549,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 76,
    viewCount: 234,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 96,
    viewCount: 428,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 21,
    viewCount: 276,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 86,
    viewCount: 868,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 74,
    viewCount: 882,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 28,
    viewCount: 453,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 42,
    viewCount: 485,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 91,
    viewCount: 574,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 36,
    viewCount: 188,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 63,
    viewCount: 991,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 66,
    viewCount: 489,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 17,
    viewCount: 462,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 52,
    viewCount: 938,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 12,
    viewCount: 187,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 79,
    viewCount: 463,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 54,
    viewCount: 677,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 86,
    viewCount: 883,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 60,
    viewCount: 642,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 70,
    viewCount: 472,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 91,
    viewCount: 791,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 16,
    viewCount: 799,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 83,
    viewCount: 460,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 92,
    viewCount: 447,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 60,
    viewCount: 309,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 28,
    viewCount: 41,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 27,
    viewCount: 767,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 77,
    viewCount: 823,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 80,
    viewCount: 363,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 6,
    viewCount: 610,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 59,
    viewCount: 635,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 34,
    viewCount: 622,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 90,
    viewCount: 626,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 73,
    viewCount: 20,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 12,
    viewCount: 474,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 67,
    viewCount: 969,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 11,
    viewCount: 405,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 27,
    viewCount: 698,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 61,
    viewCount: 381,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 13,
    viewCount: 326,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 70,
    viewCount: 116,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 29,
    viewCount: 648,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 72,
    viewCount: 64,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 76,
    viewCount: 163,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 79,
    viewCount: 759,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 67,
    viewCount: 843,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 74,
    viewCount: 325,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 85,
    viewCount: 190,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 66,
    viewCount: 253,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 45,
    viewCount: 244,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 68,
    viewCount: 672,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 14,
    viewCount: 783,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 89,
    viewCount: 479,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 45,
    viewCount: 241,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 60,
    viewCount: 96,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 61,
    viewCount: 449,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 15,
    viewCount: 644,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 98,
    viewCount: 742,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 84,
    viewCount: 702,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 2,
    viewCount: 540,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 13,
    viewCount: 209,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 24,
    viewCount: 776,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 3,
    viewCount: 658,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 72,
    viewCount: 886,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 99,
    viewCount: 465,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 16,
    viewCount: 271,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 21,
    viewCount: 806,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 46,
    viewCount: 725,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 47,
    viewCount: 538,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 42,
    viewCount: 139,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 31,
    viewCount: 646,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 67,
    viewCount: 419,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 87,
    viewCount: 899,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 91,
    viewCount: 774,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 77,
    viewCount: 245,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 36,
    viewCount: 450,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 93,
    viewCount: 633,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 20,
    viewCount: 160,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 38,
    viewCount: 903,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 67,
    viewCount: 169,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 16,
    viewCount: 125,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 31,
    viewCount: 204,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 26,
    viewCount: 685,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 28,
    viewCount: 249,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 99,
    viewCount: 571,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 31,
    viewCount: 105,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 81,
    viewCount: 221,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 67,
    viewCount: 365,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 67,
    viewCount: 858,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 57,
    viewCount: 826,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 57,
    viewCount: 436,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 58,
    viewCount: 42,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 44,
    viewCount: 154,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 38,
    viewCount: 119,
  },
  {
    isVideo: false,
    isLive: true,
    interactiveCount: 2,
    viewCount: 735,
  },
  {
    isVideo: true,
    isLive: false,
    interactiveCount: 34,
    viewCount: 177,
  },
  {
    isVideo: true,
    isLive: true,
    interactiveCount: 73,
    viewCount: 693,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 73,
    viewCount: 540,
  },
  {
    isVideo: false,
    isLive: false,
    interactiveCount: 1,
    viewCount: 319,
  },
]

export const mockFixedViewAnalysisDataBase = [
  {
    viewCount: 412,
    isLive: false,
  },
  {
    viewCount: 153,
    isLive: false,
  },
  {
    viewCount: 218,
    isLive: false,
  },
  {
    viewCount: 135,
    isLive: true,
  },
  {
    viewCount: 49,
    isLive: false,
  },
  {
    viewCount: 827,
    isLive: true,
  },
  {
    viewCount: 193,
    isLive: true,
  },
  {
    viewCount: 357,
    isLive: true,
  },
  {
    viewCount: 828,
    isLive: true,
  },
  {
    viewCount: 462,
    isLive: true,
  },
  {
    viewCount: 379,
    isLive: true,
  },
  {
    viewCount: 66,
    isLive: false,
  },
  {
    viewCount: 107,
    isLive: false,
  },
  {
    viewCount: 30,
    isLive: true,
  },
  {
    viewCount: 205,
    isLive: true,
  },
  {
    viewCount: 487,
    isLive: true,
  },
  {
    viewCount: 263,
    isLive: false,
  },
  {
    viewCount: 615,
    isLive: false,
  },
  {
    viewCount: 432,
    isLive: true,
  },
  {
    viewCount: 736,
    isLive: false,
  },
  {
    viewCount: 287,
    isLive: false,
  },
  {
    viewCount: 711,
    isLive: false,
  },
  {
    viewCount: 958,
    isLive: true,
  },
  {
    viewCount: 615,
    isLive: true,
  },
]

export const mockFixedEngagementAnalysisDataCount = [
  {
    likeCount: 529,
    interactiveCount: 587,
    commentCount: 51,
    shareCount: 7,
  },
  {
    likeCount: 152,
    interactiveCount: 175,
    commentCount: 19,
    shareCount: 4,
  },
  {
    likeCount: 985,
    interactiveCount: 1040,
    commentCount: 47,
    shareCount: 8,
  },
  {
    likeCount: 102,
    interactiveCount: 158,
    commentCount: 51,
    shareCount: 5,
  },
  {
    likeCount: 507,
    interactiveCount: 581,
    commentCount: 68,
    shareCount: 6,
  },
  {
    likeCount: 524,
    interactiveCount: 576,
    commentCount: 45,
    shareCount: 7,
  },
  {
    likeCount: 979,
    interactiveCount: 1070,
    commentCount: 87,
    shareCount: 4,
  },
  {
    likeCount: 766,
    interactiveCount: 809,
    commentCount: 41,
    shareCount: 2,
  },
  {
    likeCount: 309,
    interactiveCount: 369,
    commentCount: 60,
    shareCount: 0,
  },
  {
    likeCount: 677,
    interactiveCount: 741,
    commentCount: 59,
    shareCount: 5,
  },
  {
    likeCount: 304,
    interactiveCount: 370,
    commentCount: 57,
    shareCount: 9,
  },
  {
    likeCount: 580,
    interactiveCount: 640,
    commentCount: 51,
    shareCount: 9,
  },
  {
    likeCount: 950,
    interactiveCount: 965,
    commentCount: 8,
    shareCount: 7,
  },
  {
    likeCount: 168,
    interactiveCount: 259,
    commentCount: 85,
    shareCount: 6,
  },
  {
    likeCount: 674,
    interactiveCount: 677,
    commentCount: 1,
    shareCount: 2,
  },
  {
    likeCount: 678,
    interactiveCount: 724,
    commentCount: 37,
    shareCount: 9,
  },
  {
    likeCount: 281,
    interactiveCount: 386,
    commentCount: 98,
    shareCount: 7,
  },
  {
    likeCount: 51,
    interactiveCount: 71,
    commentCount: 18,
    shareCount: 2,
  },
  {
    likeCount: 499,
    interactiveCount: 584,
    commentCount: 76,
    shareCount: 9,
  },
  {
    likeCount: 678,
    interactiveCount: 783,
    commentCount: 99,
    shareCount: 6,
  },
  {
    likeCount: 824,
    interactiveCount: 908,
    commentCount: 75,
    shareCount: 9,
  },
  {
    likeCount: 734,
    interactiveCount: 799,
    commentCount: 60,
    shareCount: 5,
  },
  {
    likeCount: 125,
    interactiveCount: 200,
    commentCount: 74,
    shareCount: 1,
  },
  {
    likeCount: 452,
    interactiveCount: 488,
    commentCount: 32,
    shareCount: 4,
  },
]

export const mockFixedTrackingAnalysisCount = [
  { follower: 60585 },
  { follower: 55890 },
  { follower: 48722 },
  { follower: 56878 },
  { follower: 54101 },
  { follower: 54462 },
  { follower: 56490 },
  { follower: 54087 },
  { follower: 48434 },
  { follower: 48337 },
  { follower: 51307 },
  { follower: 59844 },
  { follower: 65384 },
  { follower: 66236 },
  { follower: 59776 },
  { follower: 61336 },
  { follower: 61889 },
  { follower: 66485 },
  { follower: 65223 },
  { follower: 69888 },
  { follower: 70370 },
  { follower: 69229 },
  { follower: 73216 },
  { follower: 77908 },
]
